import axios, { AxiosPromise } from 'axios';
import { IGetClassArticles, IGetStudentArticles, IGetStudentArticlesParams } from '../models/articles.model';

const uri = '/mgmt/articles';

export const getStudentArticles = (params: IGetStudentArticlesParams): AxiosPromise<IGetStudentArticles> => {
  return axios.get(uri, { params });
};

export const getClassArticles = (classCode: string): AxiosPromise<IGetClassArticles> => {
  return axios.get(`${uri}/${classCode}`);
};